import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["checkbox"];

  showHideBusinessAccountFields() {
    const element = this.checkboxTarget;
    const checked = element.checked;
    if (checked) {
      $('#vatInfoContainer').show();
    } else {
      $('#vatInfoContainer').hide();
    }
  };

  handleNewUserRegistration() {
    window.localStorage.setItem('newUserRegistration', true);
  }

  connect() {
    window.localStorage.removeItem('newUserRegistration');
    this.showHideBusinessAccountFields();
  };
}